import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "cart.icon",
  "use": "cart.icon-usage",
  "viewBox": "-13079.548 -4425.015 29.423 20.515",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"-13079.548 -4425.015 29.423 20.515\" id=\"cart.icon\"><g data-name=\"Group 1220\"><path data-name=\"LV Store Icon-01\" d=\"M104.522,131.247H81.106L80.239,128H75.1v1.253h4.18l4.189,15.762a1.832,1.832,0,1,0,2.591,1.665,1.864,1.864,0,0,0-.093-.58H96.952a1.9,1.9,0,0,0-.093.58,1.834,1.834,0,1,0,2.263-1.783v-.059h-14.4l-.547-2.069h16.982Zm-9.008,5.5H88.625l-.85-4.248h8.588Zm-7.326.538.85,4.248H84.016l-1.144-4.248Zm.547,0h6.678l-.85,4.248H89.592Zm12.877-.538H96.06l.85-4.248h5.938Zm-14.383-4.239.85,4.248H82.729l-1.144-4.248Zm7.873,9.025.85-4.248h5.5l-1.236,4.248Z\" transform=\"translate(-13154.648 -4553.015)\" fill=\"currentColor\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/cart.icon.svg
// module id = Zcfz
// module chunks = 13